export const SettingsViewMobileGrid = {
  size: 100,
  gap: 1,
  name: "settings",
  background: {
    element: "settings_page_main_bg",
    main: {
      height: 100,
    },
  },
  padding: {
    left: 5,
    right: 5,
    top: 2,
    bottom: 2,
    portrate: {
      left: 3,
      right: 3,
      top: 2,
      bottom: 2,
    },
  },
  main: [
    {
      name: "leftgrid",
      size: 100,
      type: "PortrateGridController",
      config: {
        size: 70,
        gap: 1,
        // align: "left",
        main: [
          {
            name: "empty",
            size: 2,
          },
          {
            name: "content-grid",
            type: "LandscapeGridController",
            size: 10,
            config: {
              size: 100,
              gap: 1,
              name: "header",
              main: [
                {
                  name: "header",
                  size: 80,
                  align: "left",
                  height: 80,
                },
                {
                  name: "empty",
                  size: 10,
                },
                {
                  name: "close",
                  size: 10,
                  align: "top_right",
                  height: 80,
                },
              ],
            },
          },
          {
            name: "empty",
            size: 1,
          },
          {
            name: "content_grid_bottom",
            size: 19,
            type: "LandscapeGridController",
            config: {
              size: 100,
              gap: 1,
              name: "content",
              main: [
                {
                  name: "background_music_holder",
                  size: 50,
                  bounds: {
                    width: 513,
                    height: 152,
                  },
                },
                {
                  name: "sound_effects_holder",
                  size: 50,
                  bounds: {
                    width: 513,
                    height: 152,
                  },
                },
              ],
            },
          },
          {
            name: "content_grid_bottom1",
            size: 19,
            type: "LandscapeGridController",
            config: {
              size: 100,
              gap: 1,
              name: "content",
              main: [
                {
                  name: "fast_spin_holder",
                  size: 50,
                  bounds: {
                    width: 513,
                    height: 152,
                  },
                },
                {
                  name: "game_animation_holder",
                  size: 50,
                  bounds: {
                    width: 513,
                    height: 152,
                  },
                },
              ],
            },
          },
          {
            name: "content_grid_bottom2",
            size: 19,
            type: "LandscapeGridController",
            config: {
              size: 100,
              gap: 1,
              name: "content",
              main: [
                {
                  name: "keyboard_shortcuts_holder",
                  size: 50,
                  bounds: {
                    width: 513,
                    height: 152,
                  },
                },
                {
                  name: "splash_screen_holder",
                  size: 50,
                  bounds: {
                    width: 513,
                    height: 152,
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
  portrate: [
    {
      name: "header_grid_portrait",
      type: "LandscapeGridController",
      size: 10,
      config: {
        size: 100,
        gap: 0,
        name: "header_portrait",
        maxWidth: "reel",
        main: [
          {
            name: "header",
            size: 70,
            align: "left",
            height: 70,
          },
          {
            name: "empty",
            size: 20,
          },
          {
            name: "close",
            size: 10,
            align: "right",
            bounds: {
              width: 60,
              height: 60,
            },
          },
        ],
      },
    },
    {
      name: "background_music_holder",
      size: 15,
      bounds: {
        width: 513,
        height: 152,
      },
    },
    {
      name: "fast_spin_holder",
      size: 15,
      bounds: {
        width: 513,
        height: 152,
      },
    },
    {
      name: "keyboard_shortcuts_holder",
      size: 15,
      bounds: {
        width: 513,
        height: 152,
      },
    },
    {
      name: "sound_effects_holder",
      size: 15,
      bounds: {
        width: 513,
        height: 152,
      },
    },
    {
      name: "game_animation_holder",
      size: 15,
      bounds: {
        width: 513,
        height: 152,
      },
    },
    {
      name: "splash_screen_holder",
      size: 15,
      bounds: {
        width: 513,
        height: 152,
      },
    },
  ],
};
